import api from '@/services/api-recebimentoweb';

const ENDPOINT = 'cliente';

export default {
namespaced: true,

state: {
    list: [],
},

getters: {
    list: (state) => state.list,
},

mutations: {
    SET_LIST(state, data) {
    state.list = data ?? [];
    },
},

actions: {

    async findAll({ commit }, params = {}) {
    const { data } = await api.get(ENDPOINT, { params });
    commit('SET_LIST', data);
    return data;
    },

    async getListaClientes({ commit }, params = {}) {
    const { data } = await api.get(`${ENDPOINT}/lista`, { params });
    commit('SET_LIST', data);
    return data;
    },

    async findById(_, { id }) {
    if (!id) throw new Error('O ID é obrigatório para a busca.');
    const { data } = await api.get(`${ENDPOINT}/${id}`);
    return data;
    },
    
    async create(_, payload) {
    const { data } = await api.post(ENDPOINT, payload);
    return data;
    },

    async update(_, { id, payload }) {
    if (!id) throw new Error('O ID é obrigatório para a atualização.');
    const { data } = await api.put(`${ENDPOINT}/${id}`, payload);
    return data;
    },

    async remove(_, { id }) {
    if (!id) throw new Error('O ID é obrigatório para a remoção.');
    const { data } = await api.delete(`${ENDPOINT}/${id}`);
    return data;
    },
    },
};